import React from 'react';
import { connect } from 'react-redux';
import { RadioButton, Toggle } from 'material-ui';
import NettHeader from './nett.jsx';
import CommissionHeader from './commission.jsx';
import DiscountHeader from './discount.jsx';
import R from 'ramda';

class ActionAreaHeader extends React.Component {
  constructor() {
    super();
    this.state = {
      showRoundSettings: false,
    };
  }
  toggleShowRoundSettings = () => this.setState({ showRoundSettings: !this.state.showRoundSettings })
  render() {
    const {
      rateType,
      changeMeasure,
      retailNettMeasure,
      changeRoundSettings,
      roundingSetting,
    } = this.props;
    const cents = roundingSetting && roundingSetting.get('cents') || 1;
    const roundType = roundingSetting && roundingSetting.get('roundType') || 'normal';
    const {
      showRoundSettings,
    } = this.state;
    const HeaderContent = (() => {
      if (rateType) {
        if (R.equals(rateType, 'nett')) return NettHeader;
        if (R.equals(rateType, 'commission')) return CommissionHeader;
        if (R.equals(rateType, 'discount')) return DiscountHeader;
      }
      return NettHeader;
    })();
    return (
      <div style={{ lineHeight: '48px', borderBottom: '1px solid #eeeeee', padding: '0 16px' }}>
        <Toggle
          toggled={showRoundSettings}
          label="Show Rounding Settings"
          labelPosition="right"
          style={{ marginTop: '8px', width: '50%' }}
          onToggle={this.toggleShowRoundSettings}
        />
        <div
          style={{ borderBottom: '1px solid #eee', display: showRoundSettings ? 'flex' : 'none' }}
        >
          <div style={{ width: '50%' }}>
            Rounding Settings:
            <RadioButton label="Round to the neareast" checked={roundType === 'normal'} onCheck={() => changeRoundSettings({ roundType: 'normal' })} />
            <RadioButton label="Always round up" checked={roundType === 'alwaysUp'} onCheck={() => changeRoundSettings({ roundType: 'alwaysUp' })} />
            <RadioButton label="Always round down" checked={roundType === 'alwaysDown'} onCheck={() => changeRoundSettings({ roundType: 'alwaysDown' })} />
          </div>
          <div style={{ width: '50%' }}>
            To the nearest:
            <RadioButton label="dollar" checked={cents === 100} onCheck={() => changeRoundSettings({ cents: 100 })} />
            <RadioButton label="50 cents" checked={cents === 50} onCheck={() => changeRoundSettings({ cents: 50 })} />
            <RadioButton label="25 cents" checked={cents === 25} onCheck={() => changeRoundSettings({ cents: 25 })} />
            <RadioButton label="1 cent" checked={cents === 1} onCheck={() => changeRoundSettings({ cents: 1 })} />
          </div>
        </div>
        <HeaderContent changeMeasure={changeMeasure} retailNettMeasure={retailNettMeasure} />
      </div>
    );
  }
}

const mapStateToProps = ({ contracting: { massRateChange } }) => ({
  roundingSetting: massRateChange.getIn([massRateChange.get('updateType'), 'roundingSetting']),
  rateType: massRateChange.get('rateType'),
  retailNettMeasure: massRateChange.getIn([
    massRateChange.get('updateType'),
    `${massRateChange.get('rateType')}Measure`,
  ]),
});

export default connect(mapStateToProps)(ActionAreaHeader);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/header/header.jsx